import { render, staticRenderFns } from "./historyData.vue?vue&type=template&id=f49def72"
import script from "./historyData.vue?vue&type=script&lang=js"
export * from "./historyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports